/* ============================================
   Real Madrid IL - Theme JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* --- Mobile Menu --- */
  var mobileToggle = document.querySelector('.mobile-menu-toggle');
  var mobileMenu = document.querySelector('.mobile-menu');
  var mobileOverlay = document.querySelector('.mobile-menu__overlay');
  var mobileClose = document.querySelector('.mobile-menu__close');

  function openMobileMenu() {
    if (!mobileMenu) return;
    closeSearch();
    mobileMenu.classList.add('active');
    if (mobileOverlay) mobileOverlay.classList.add('active');
    if (mobileToggle) mobileToggle.classList.add('active');
    mobileToggle && mobileToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';
    /* Floating widgets (Jerzy launcher/dismiss z9998-9999, Nagishly trigger
       z max-int) otherwise sit ABOVE the menu drawer and cover items like
       "מדריך מידות". Flag the body so CSS can hide them while the menu is open. */
    document.body.classList.add('mobile-menu-open');
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('active');
    if (mobileOverlay) mobileOverlay.classList.remove('active');
    if (mobileToggle) {
      mobileToggle.classList.remove('active');
      mobileToggle.setAttribute('aria-expanded', 'false');
    }
    // Reset all submenus
    var openSubs = mobileMenu.querySelectorAll('.mobile-menu__submenu.active');
    for (var s = 0; s < openSubs.length; s++) openSubs[s].classList.remove('active');
    var expandedTriggers = mobileMenu.querySelectorAll('[data-submenu].expanded');
    for (var t = 0; t < expandedTriggers.length; t++) {
      expandedTriggers[t].classList.remove('expanded');
      expandedTriggers[t].setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
    document.body.style.touchAction = '';
    document.body.classList.remove('mobile-menu-open');
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // Restore body scroll if user navigates away with a drawer/menu open
  window.addEventListener('beforeunload', function () {
    document.body.style.overflow = '';
  });

  // Mobile submenu toggles (supports nested levels)
  var mobileSubTriggers = document.querySelectorAll('[data-submenu]');
  for (var i = 0; i < mobileSubTriggers.length; i++) {
    mobileSubTriggers[i].addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById(this.dataset.submenu);
      if (target) {
        target.classList.toggle('active');
        this.classList.toggle('expanded');
        this.setAttribute('aria-expanded', target.classList.contains('active'));
      }
    });
  }

  /* --- Search Modal --- */
  var searchBtn = document.querySelector('[data-search-toggle]');
  var searchModal = document.getElementById('search-modal');
  var searchOverlay = document.getElementById('search-overlay');
  var searchInput = document.getElementById('search-input');

  window.openSearch = function() {
    if (!searchModal) return;
    searchModal.classList.add('active');
    if (searchOverlay) searchOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (searchInput) searchInput.focus(); }); });
    /* 30.8.26: this used to prefetch the whole catalogue (6.6MB over 6
       /products.json pages) the moment the modal opened, because the suggest
       endpoint was dead and the cache was the only thing that could answer.
       templates/search.suggest.liquid answers in one request now, so the cache
       is a fallback and loads only if that request fails. */
    if (window.jrsTrack) window.jrsTrack('open', { source: 'modal' });
  };

  window.closeSearch = function() {
    if (!searchModal) return;
    searchModal.classList.remove('active');
    if (searchOverlay) searchOverlay.classList.remove('active');
    document.body.style.overflow = '';
    document.body.style.touchAction = '';
    if (searchInput) searchInput.value = '';
  }

  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);

  /* --- Floating Header: shadow on scroll + adaptive text colour --- */
  var header = document.querySelector('.site-header');

  // WCAG relative luminance of a computed backgroundColor string.
  // Returns null for transparent / semi-transparent layers (< 0.5 alpha):
  // scrims and tint overlays must not decide the header's contrast.
  function relLum(str) {
    var m = (str || '').match(/[\d.]+/g);
    if (!m || m.length < 3) return null;
    var a = m.length >= 4 ? parseFloat(m[3]) : 1;
    if (a < 0.5) return null;
    function lin(v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
    return 0.2126 * lin(+m[0]) + 0.7152 * lin(+m[1]) + 0.0722 * lin(+m[2]);
  }

  // Is whatever sits behind the header at (x,y) dark?
  // Deterministic: computed background colors only. The previous canvas
  // pixel-sampler read CDN <img> pixels, which taint the canvas cross-origin,
  // so it silently fell back to "light" over dark photos - that is what made
  // the header flip colours at the wrong moments. Images/videos are skipped;
  // their section's background color (or data-header-dark) decides instead.
  function darkAt(x, y) {
    var stack = document.elementsFromPoint(x, y);
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (el === header || header.contains(el)) continue;      // skip the header itself
      if (el.hasAttribute && el.hasAttribute('data-header-dark')) return true;   // manual override
      var tag = el.tagName;
      if (tag === 'IMG' || tag === 'VIDEO' || tag === 'PICTURE' || tag === 'svg') continue;
      var L = relLum(getComputedStyle(el).backgroundColor);
      if (L !== null) return L < 0.35;                          // first opaque layer wins
    }
    return false;  // nothing opaque found → assume light page background
  }

  // Toggle the floating-pill state + the body flag that slides the promo bar
  // up out of view. Hysteresis (on > 8px, off <= 2px) so tiny scroll jitter
  // around a single threshold can't make the pill flicker in and out.
  var floatOn = false;
  function setScrolled() {
    var sy = window.pageYOffset || 0;
    if (!floatOn && sy > 8) floatOn = true;
    else if (floatOn && sy <= 2) floatOn = false;
    if (header) header.classList.toggle('scrolled', floatOn);
    document.body.classList.toggle('is-scrolled', floatOn);
  }

  // Sample what's behind the header at 5 points along its midline and flip
  // to the on-dark skin on majority. Runs every scroll frame - darkAt() is
  // now just elementsFromPoint + computed-style reads (no canvas readback),
  // so the flip lands the moment the header crosses a section boundary
  // instead of lagging behind a throttle window.
  function updateContrast() {
    if (!header) return;
    var r = header.getBoundingClientRect();
    var y = Math.max(2, r.top + r.height / 2);
    var votes = 0, pts = [0.12, 0.31, 0.5, 0.69, 0.88];
    for (var i = 0; i < pts.length; i++) {
      if (darkAt(r.left + r.width * pts[i], y)) votes++;
    }
    header.classList.toggle('site-header--on-dark', votes * 2 > pts.length);
  }

  var ticking = false, scrollIdle;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      setScrolled();
      updateContrast();
      ticking = false;
    });
    // settle: once more after scrolling stops, for a correct final state
    clearTimeout(scrollIdle);
    scrollIdle = setTimeout(updateContrast, 120);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { setScrolled(); updateContrast(); }, { passive: true });
  window.addEventListener('load', function () { setScrolled(); updateContrast(); });
  setScrolled();
  updateContrast();

  /* --- Tabs --- */
  var tabGroups = document.querySelectorAll('[data-tab-group]');
  for (var tg = 0; tg < tabGroups.length; tg++) {
    (function (group) {
      var buttons = group.querySelectorAll('.tab-btn');
      var contents = group.querySelectorAll('.tab-content');

      for (var b = 0; b < buttons.length; b++) {
        buttons[b].addEventListener('click', function () {
          var target = this.dataset.tab;

          for (var j = 0; j < buttons.length; j++) {
            buttons[j].classList.remove('active');
            buttons[j].setAttribute('aria-selected', 'false');
          }
          for (var k = 0; k < contents.length; k++) {
            contents[k].classList.remove('active');
          }

          this.classList.add('active');
          this.setAttribute('aria-selected', 'true');
          var targetEl = group.querySelector('[data-tab-content="' + target + '"]');
          if (targetEl) targetEl.classList.add('active');
        });
      }

      // Keyboard navigation for tabs (arrow keys)
      for (var a = 0; a < buttons.length; a++) {
        buttons[a].addEventListener('keydown', function (e) {
          var idx = Array.prototype.indexOf.call(buttons, this);
          var next = -1;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            // RTL: ArrowLeft = next, ArrowRight = prev
            if (e.key === 'ArrowLeft') {
              next = (idx + 1) % buttons.length;
            } else {
              next = (idx - 1 + buttons.length) % buttons.length;
            }
            e.preventDefault();
            buttons[next].focus();
            buttons[next].click();
          }
        });
      }
    })(tabGroups[tg]);
  }

  /* --- Hero Slider --- */
  var heroSlider = document.querySelector('.hero-slider');
  if (heroSlider) {
    var slides = heroSlider.querySelectorAll('.hero-slide');
    var dots = heroSlider.querySelectorAll('.hero-slider__dot');
    var currentSlide = 0;
    var slideInterval = null;

    function goToSlide(index) {
      for (var s = 0; s < slides.length; s++) slides[s].classList.remove('active');
      for (var d = 0; d < dots.length; d++) dots[d].classList.remove('active');
      if (slides[index]) slides[index].classList.add('active');
      if (dots[index]) dots[index].classList.add('active');
      currentSlide = index;
    }

    function nextSlide() {
      goToSlide((currentSlide + 1) % slides.length);
    }

    for (var di = 0; di < dots.length; di++) {
      (function (i) {
        dots[i].addEventListener('click', function () {
          goToSlide(i);
          if (slideInterval) clearInterval(slideInterval);
          slideInterval = setInterval(nextSlide, 5000);
        });
      })(di);
    }

    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (slides.length > 1 && !prefersReducedMotion) {
      slideInterval = setInterval(nextSlide, 5000);
    }

    // Pause slider when tab is hidden to prevent memory waste
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (slideInterval) clearInterval(slideInterval);
        slideInterval = null;
      } else if (slides.length > 1 && !prefersReducedMotion) {
        slideInterval = setInterval(nextSlide, 5000);
      }
    });
  }

  /* --- Carousel --- */
  var carousels = document.querySelectorAll('.carousel-container');
  for (var ci = 0; ci < carousels.length; ci++) {
    (function (carousel) {
      var track = carousel.querySelector('.carousel-track');
      var prevBtn = carousel.querySelector('.carousel-btn--prev');
      var nextBtn = carousel.querySelector('.carousel-btn--next');

      if (!track || !track.firstElementChild) return;

      var isMobile = function () { return window.innerWidth < 768; };

      var scrollAmount = 0;
      var cardWidth = track.firstElementChild.offsetWidth || 250;
      var gap = parseInt(getComputedStyle(track).gap) || 16;
      var step = cardWidth + gap;

      function updateButtons() {
        if (isMobile()) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (prevBtn) prevBtn.style.opacity = scrollAmount <= 0 ? '0.3' : '1';
        if (nextBtn) nextBtn.style.opacity = scrollAmount >= maxScroll ? '0.3' : '1';
      }

      // Recalculate on resize (debounced)
      var resizeTimer = null;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (isMobile()) {
            track.style.transform = '';
            scrollAmount = 0;
            return;
          }
          cardWidth = track.firstElementChild ? track.firstElementChild.offsetWidth : 250;
          gap = parseInt(getComputedStyle(track).gap) || 16;
          step = cardWidth + gap;
          scrollAmount = Math.min(scrollAmount, Math.max(0, track.scrollWidth - track.clientWidth));
          track.style.transform = 'translateX(-' + scrollAmount + 'px)';
          updateButtons();
        }, 150);
      }, { passive: true });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          if (isMobile()) return;
          scrollAmount = Math.max(0, scrollAmount - step * 2);
          track.style.transform = 'translateX(-' + scrollAmount + 'px)';
          updateButtons();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          if (isMobile()) return;
          var max = track.scrollWidth - track.clientWidth;
          scrollAmount = Math.min(max, scrollAmount + step * 2);
          track.style.transform = 'translateX(-' + scrollAmount + 'px)';
          updateButtons();
        });
      }

      // Desktop drag support (mouse)
      var isDragging = false;
      var startX = 0;
      var currentX = 0;

      // Touch on mobile → let CSS native scroll & scroll-snap handle it
      // Touch on desktop → JS transform
      track.addEventListener('touchstart', function (e) {
        if (isMobile()) return;
        isDragging = true;
        startX = e.touches[0].clientX;
        currentX = startX;
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        if (isMobile() || !isDragging) return;
        currentX = e.touches[0].clientX;
        var diff = startX - currentX;
        track.style.transform = 'translateX(-' + (scrollAmount + diff) + 'px)';
      }, { passive: true });

      track.addEventListener('touchend', function () {
        if (isMobile() || !isDragging) return;
        isDragging = false;
        var diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          var max = track.scrollWidth - track.clientWidth;
          if (diff > 0) {
            scrollAmount = Math.min(max, scrollAmount + step);
          } else {
            scrollAmount = Math.max(0, scrollAmount - step);
          }
        }
        track.style.transform = 'translateX(-' + scrollAmount + 'px)';
        updateButtons();
      });

      updateButtons();

      // Mobile scroll hint - injected after the carousel-container
      if (isMobile()) {
        var hint = document.createElement('div');
        hint.className = 'scroll-hint';
        hint.innerHTML = '<span class="scroll-hint__pill">גללו לראות את הכל \u2190</span>';
        carousel.parentNode.insertBefore(hint, carousel.nextSibling);
        track.addEventListener('scroll', function hideOnScroll() {
          if (Math.abs(track.scrollLeft) > 10) {
            hint.classList.add('is-hidden');
            track.removeEventListener('scroll', hideOnScroll);
          }
        }, { passive: true });
      }

      // Auto-advance every 5 seconds
      var AUTO_INTERVAL = 5000;
      var PAUSE_AFTER_INTERACT_MS = 8000;
      var autoTimer = null;
      var userPausedUntil = 0;
      var isHovered = false;

      function getCurrentCardWidth() {
        var first = track.firstElementChild;
        return first ? first.offsetWidth : 250;
      }

      function autoAdvance() {
        if (isHovered) return;
        if (Date.now() < userPausedUntil) return;
        if (document.hidden) return;
        if (!track.isConnected) { stopAuto(); return; }
        if (isMobile()) return; // mobile: user scrolls natively, no auto-advance interference

        var maxD = track.scrollWidth - track.clientWidth;
        if (scrollAmount >= maxD - 10) {
          // Disable transition for instant reset (no backward slide animation)
          track.style.transition = 'none';
          scrollAmount = 0;
          track.style.transform = 'translateX(0)';
          // Re-enable transition after browser paints the reset position
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              track.style.transition = '';
            });
          });
        } else {
          scrollAmount = Math.min(maxD, scrollAmount + step);
          track.style.transform = 'translateX(-' + scrollAmount + 'px)';
        }
        updateButtons();
      }

      function startAuto() {
        stopAuto();
        if (isMobile()) return; // no auto-advance on mobile
        if (track.scrollWidth <= track.clientWidth + 10) return;
        autoTimer = setInterval(autoAdvance, AUTO_INTERVAL);
      }
      function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
      function pauseFor(ms) { userPausedUntil = Date.now() + ms; }

      // Pause on hover (desktop)
      carousel.addEventListener('mouseenter', function(){ isHovered = true; });
      carousel.addEventListener('mouseleave', function(){ isHovered = false; });

      // Pause on user interaction
      track.addEventListener('touchstart', function(){ pauseFor(PAUSE_AFTER_INTERACT_MS); }, { passive: true });
      if (prevBtn) prevBtn.addEventListener('click', function(){ pauseFor(PAUSE_AFTER_INTERACT_MS); });
      if (nextBtn) nextBtn.addEventListener('click', function(){ pauseFor(PAUSE_AFTER_INTERACT_MS); });

      // Proper visibility handling - no CPU waste on hidden tabs
      document.addEventListener('visibilitychange', function() {
        if (document.hidden) stopAuto();
        else startAuto();
      });

      // Cleanup on page navigation (SPA-safe)
      window.addEventListener('pagehide', stopAuto);

      startAuto();
    })(carousels[ci]);
  }

  /* --- Countdown Timer --- */
  var countdowns = document.querySelectorAll('[data-countdown]');
  for (var cdi = 0; cdi < countdowns.length; cdi++) {
    (function (el) {
      var targetDate = new Date(el.dataset.countdown).getTime();
      if (isNaN(targetDate)) return; // Skip invalid dates

      var daysEl = el.querySelector('[data-days]');
      var hoursEl = el.querySelector('[data-hours]');
      var minutesEl = el.querySelector('[data-minutes]');
      var secondsEl = el.querySelector('[data-seconds]');
      var matchdayEl = el.querySelector('.countdown-matchday');
      var timerEl = el.querySelector('.countdown-timer');
      var intervalId = null;

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function updateCountdown() {
        if (!el.isConnected) { if (intervalId) clearInterval(intervalId); return; }
        var now = new Date().getTime();
        var distance = targetDate - now;

        if (distance < 0) {
          if (timerEl) timerEl.style.display = 'none';
          if (matchdayEl) matchdayEl.style.display = 'block';
          if (intervalId) clearInterval(intervalId);
          return;
        }

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      updateCountdown();
      intervalId = setInterval(updateCountdown, 1000);
    })(countdowns[cdi]);
  }

  /* --- Scroll Animations --- */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      // Collect everything crossing the threshold in this batch (typically one grid row)
      var hits = [];
      for (var ei = 0; ei < entries.length; ei++) {
        if (entries[ei].isIntersecting) hits.push(entries[ei].target);
      }
      // Sort by document order so the cascade flows source-order (top-start first)
      hits.sort(function (a, b) {
        return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
      });
      // Stagger the batch: 70ms per item, capped so deep rows don't lag
      for (var hi = 0; hi < hits.length; hi++) {
        var node = hits[hi];
        if (hits.length > 1 && !node.hasAttribute('data-animate-delay')) {
          node.style.transitionDelay = (Math.min(hi, 6) * 0.09) + 's';
        }
        node.classList.add('visible');
        observer.unobserve(node);
      }
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

    var animElements = document.querySelectorAll('[data-animate]');
    var viewH = window.innerHeight;
    for (var ai = 0; ai < animElements.length; ai++) {
      var el = animElements[ai];
      // Above-the-fold: show immediately without animation (prevents jump on load)
      if (el.getBoundingClientRect().top < viewH) {
        el.classList.add('visible');
      } else {
        observer.observe(el);
      }
    }
  } else {
    // Fallback: show all elements immediately
    var fallbackEls = document.querySelectorAll('[data-animate]');
    for (var fi = 0; fi < fallbackEls.length; fi++) {
      fallbackEls[fi].classList.add('visible');
    }
  }

  // Safety net: only force-reveal elements that are ALREADY in/above the viewport
  // (covers a stuck/blocked observer). Below-the-fold elements are left to the
  // observer so their scroll-reveal animation still fires when the user reaches them.
  function revealPassed() {
    var stuck = document.querySelectorAll('[data-animate]:not(.visible)');
    var vh = window.innerHeight;
    for (var si = 0; si < stuck.length; si++) {
      if (stuck[si].getBoundingClientRect().top < vh) {
        stuck[si].classList.add('visible');
      }
    }
  }
  setTimeout(revealPassed, 2500);

  // A programmatic jump (anchor link, browser scroll restore, "load more" then
  // jump) moves the viewport past rows without ever intersecting them, so the
  // observer never fires for those and they stay at opacity:0 for good - measured
  // 26 of 250 cards stuck permanently on the men's collection. Re-run the same
  // above-the-fold sweep after scrolling settles. rAF-throttled, and it only ever
  // reveals rows the viewport has already reached, so scroll-in animations below
  // still play normally.
  var revealTick = false;
  window.addEventListener('scroll', function () {
    if (revealTick) return;
    revealTick = true;
    window.requestAnimationFrame(function () {
      revealTick = false;
      revealPassed();
    });
  }, { passive: true });

  /* --- Cart Drawer ---
     Cart drawer is fully managed by CartAPI in theme.liquid inline script.
     Open/close are handled there via event delegation on [data-cart-toggle],
     #cart-close, #cart-overlay, and Escape key. Do not add cart listeners here. */

  // Close mobile menu and search on Escape (cart drawer handles its own)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileMenu();
      closeSearch();
    }
  });

  /* --- Recently-viewed recorder ---------------------------------------
     Records every product-page visit. MOVED HERE from
     snippets/continue-shopping.liquid on 13.8.26 when that widget was
     replaced by snippets/cart-progress-chip.liquid. It must live in a
     globally loaded file: sections/recently-viewed.liquid renders on the
     homepage only, so it can never record a product view.

       rv_products  - array of handles, max 20, newest first. SHAPE UNCHANGED:
                      sections/recently-viewed.liquid reads it as-is.
       rv_meta      - handle -> {t: title, u: image}, so a consumer can render
                      a card with zero network requests. Capped at 20 keys.
       rv_last_seen - ms of the last product view.

     sections/recently-viewed.liquid also appends to rv_products on the homepage
     (same shape, harmless), but it does NOT maintain rv_meta or rv_last_seen.
     Those two keys have exactly one writer: this block. */
  (function recordProductView() {
    if (!/^\/products\//.test(window.location.pathname)) return;
    var handle = window.location.pathname.split('/products/')[1].split('?')[0].split('#')[0];
    if (!handle) return;

    function meta(sel) {
      var m = document.querySelector(sel);
      return (m && m.getAttribute('content')) || '';
    }

    try {
      var list = JSON.parse(localStorage.getItem('rv_products')) || [];
      list = list.filter(function (h) { return h !== handle; });
      list.unshift(handle);
      list = list.slice(0, 20);
      localStorage.setItem('rv_products', JSON.stringify(list));

      // Before rv_meta: it is the bigger write, so a quota failure there must
      // not also cost us the timestamp.
      localStorage.setItem('rv_last_seen', String(Date.now()));

      var store = JSON.parse(localStorage.getItem('rv_meta')) || {};
      store[handle] = {
        // og:title carries the " | Jerseys.co.il" SEO suffix - strip it so the
        // value is renderable as a card title as-is.
        t: (meta('meta[property="og:title"]') || document.title).split('|')[0].trim(),
        u: meta('meta[property="og:image"]')
      };
      // Drop metadata for handles that fell off the list
      var kept = {};
      for (var i = 0; i < list.length; i++) {
        if (store[list[i]]) kept[list[i]] = store[list[i]];
      }
      localStorage.setItem('rv_meta', JSON.stringify(kept));
    } catch (e) {}
  })();

  /* --- Reduced Motion --- */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.style.setProperty('--transition-fast', '0ms');
    document.documentElement.style.setProperty('--transition-base', '0ms');
    document.documentElement.style.setProperty('--transition-slow', '0ms');
  }

});
